import React from 'react';
import styled from 'styled-components'

const Hygiene = ({ width }) => {
  return (
    <svg
      overflow="initial"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={`100%`}
      height={`100%`}
    >
      <path
        d="M483.335,279.885c2.552-3.762,4.346-8.025,5.596-12.509C503.099,257.464,512,241.487,512,224	c0-25.76-18.365-47.313-42.677-52.26c0.01-0.365,0.01-0.719,0.01-1.073c0-21.844-16.5-39.906-37.688-42.375	c-7.479-13.188-21.531-21.625-36.979-21.625c-15.438,0-29.521,8.552-36.979,21.667c-3.781-0.427-7.469-0.479-11.354,0.031	c-7.448-13.135-21.531-21.698-37-21.698c-8.271,0-16.281,2.448-23.125,6.927c-5.521-4.417-12.365-6.927-19.542-6.927	c-17.646,0-32,14.354-32,32c0,13.917,8.938,25.792,21.375,30.188c-0.031,0.604-0.042,1.208-0.042,1.813c0,0.365,0,0.74,0.01,1.104	c-3.49-0.729-7.063-1.104-10.677-1.104c-25.754,0-47.298,18.353-52.254,42.667h-9.225c-5.375,0-8.135-3.542-9.073-5.063	c-0.948-1.521-2.875-5.573-0.469-10.375l34.25-68.5c3.125-6.24,4.771-13.229,4.771-20.208c0-24.917-20.271-45.188-45.188-45.188H160	c-2.958,0-5.781,1.229-7.802,3.385L37.292,190.5C13.25,216.271,0,249.875,0,285.115V384c0,58.813,47.854,106.667,106.667,106.667	H384c23.531,0,42.667-19.135,42.667-42.667c0-7.806-2.259-15.033-5.934-21.333H448c23.531,0,42.667-19.135,42.667-42.667	c0-8.845-2.707-17.066-7.332-23.885C499.969,354.288,512,338.602,512,320S499.969,285.712,483.335,279.885z"
        fill="#303c42"
      />
      <path
        d="M245.333,192c9.229,0,17.75,3.938,23.979,11.094c2.021,2.323,5.24,3.26,8.313,3.271h0.01	c3.083,0,6.292-1.719,8.323-4.031c2-2.146,3.031-5.01,2.854-7.927c-0.177-2.927-1.542-5.646-3.781-7.531	c-4.896-4.104-7.698-10.021-7.698-16.208c0-2.385,0.469-4.792,1.417-7.354c1.292-3.448,0.708-7.323-1.542-10.24	s-5.875-4.396-9.51-4.104c-0.958,0.094-1.875,0.302-1.031,0.365c-5.885,0-10.667-4.781-10.667-10.667	c-0.01-9.635,14.688-14.188,19.781-4.938c1.688,3.073,4.76,5.125,8.25,5.479c3.396,0.375,6.906-1,9.198-3.656	c10.49-12.292,32.167-7.219,36.49,7.979c0.781,2.75,2.625,5.063,5.135,6.438c2.5,1.354,5.427,1.698,8.177,0.865	c7.177-2.146,12.021-1.906,17.958-0.115c2.708,0.802,5.667,0.51,8.167-0.854c2.5-1.365,4.354-3.667,5.146-6.406	c2.625-9.104,11-15.458,20.365-15.458c8.99,0,17.042,5.771,20.031,14.365c1.5,4.292,6.802,6.979,11.406,6.979	c11.75,0.083,21.896,9.375,21.896,21.323c0,2.313-0.448,4.667-1.375,7.219c-1.229,3.375,0.01,7.052,2.156,9.938	c2.021,2.698,5.781,4.198,9.198,4.198c17.99,0.104,32.688,14.104,32.688,31.979c0,5.215-1.432,10.181-3.762,14.664	c-6.664-14.893-21.557-25.331-38.905-25.331H215.298C219.716,200.944,231.445,192,245.333,192z"
        fill="#fafafa"
      />
      <g fill="#fff">
        <path
          d="M423.4,153.031c1.5,4.292,6.802,6.979,11.406,6.979 c4.362,0.031,8.277,1.647,11.76,3.88c-2.999-8.454-11.092-14.48-20.462-14.547c-1.775,0-3.605-0.505-5.329-1.242 C421.81,149.629,422.772,151.227,423.4,153.031z"
          opacity="0.2"
        />
        <path
          d="M484.641,235.07c0.707,1.234,1.68,2.288,2.264,3.594 c0.193-0.372,0.276-0.793,0.457-1.172C486.525,236.609,485.551,235.88,484.641,235.07z"
          opacity="0.2"
        />
        <path
          d="M457.483,198.49c2.021,2.698,5.781,4.198,9.198,4.198 c7.835,0.046,14.951,2.837,20.594,7.327c-5.316-10.651-16.41-17.919-29.296-17.993c-0.919,0-1.829-0.372-2.758-0.585 C455.243,193.928,455.938,196.411,457.483,198.49z"
          opacity="0.2"
        />
        <path
          d="M338.421,154.198c0.781,2.75,2.625,5.063,5.135,6.438 c2.5,1.354,5.427,1.698,8.177,0.865c7.177-2.146,12.021-1.906,17.958-0.115c2.708,0.802,5.667,0.51,8.167-0.854 c2.5-1.365,4.354-3.667,5.146-6.406c2.625-9.104,11-15.458,20.365-15.458c4.069,0,7.872,1.315,11.174,3.406 C411.467,133.656,403.544,128,394.667,128c-9.365,0-17.74,6.354-20.365,15.458c-0.792,2.74-2.646,5.042-5.146,6.406 c-2.5,1.365-5.458,1.656-8.167,0.854c-5.938-1.792-10.781-2.031-17.958,0.115c-2.092,0.634-4.237,0.391-6.268-0.266 C337.384,151.733,338.044,152.874,338.421,154.198z"
          opacity="0.2"
        />
        <path
          d="M254.035,202.667c9.022,0,17.333,3.813,23.523,10.667h16.665 c0.125-0.129,0.319-0.199,0.436-0.333c2-2.146,3.031-5.01,2.854-7.927c-0.177-2.927-1.542-5.646-3.781-7.531 c-4.896-4.104-7.698-10.021-7.698-16.208c0-2.385,0.469-4.792,1.417-7.354c1.292-3.448,0.708-7.323-1.542-10.24 c-1.676-2.173-4.182-3.232-6.82-3.671c-0.051,1.091,0.055,2.191-0.34,3.243c-0.948,2.563-1.417,4.969-1.417,7.354 c0,6.188,2.802,12.104,7.698,16.208c2.24,1.885,3.604,4.604,3.781,7.531c0.177,2.917-0.854,5.781-2.854,7.927 c-2.031,2.313-5.24,4.031-8.323,4.031h-0.01c-3.073-0.01-6.292-0.948-8.313-3.271c-6.229-7.156-14.75-11.094-23.979-11.094 c-13.888,0-25.617,8.944-30.035,21.333h15.447C236.564,206.924,244.702,202.667,254.035,202.667z"
          opacity="0.2"
        />
        <path
          d="M264.775,148.951c0.398-9.354,14.688-13.673,19.708-4.555 c1.688,3.073,4.76,5.125,8.25,5.479c3.396,0.375,6.906-1,9.198-3.656c7.029-8.237,18.991-8.542,27.479-3.362 c-4.797-14.628-25.861-19.397-36.181-7.305c-2.292,2.656-5.802,4.031-9.198,3.656c-3.49-0.354-6.563-2.406-8.25-5.479 c-5.094-9.25-19.792-4.698-19.781,4.938C256,143.882,259.824,148.026,264.775,148.951z"
          opacity="0.2"
        />
      </g>
      <path
        d="M469.333,341.333h-160c-5.896,0-10.667,4.771-10.667,10.667c0,5.896,4.771,10.667,10.667,10.667H448	c11.76,0,21.333,9.573,21.333,21.333c0,11.76-9.573,21.333-21.333,21.333H277.333c-5.896,0-10.667,4.771-10.667,10.667	c0,5.896,4.771,10.667,10.667,10.667H384c11.76,0,21.333,9.573,21.333,21.333c0,11.76-9.573,21.333-21.333,21.333H106.667	c-47.052,0-85.333-38.281-85.333-85.333v-98.885c0-29.813,11.208-58.25,31.563-80.052l111.74-119.729h3.51	c13.156,0,23.854,10.698,23.854,23.854c0,3.677-0.875,7.375-2.521,10.667l-34.25,68.5c-5,9.99-4.469,21.635,1.396,31.135	c5.875,9.5,16.052,15.177,27.229,15.177H448c11.76,0,21.333,9.573,21.333,21.333c0,11.76-9.573,21.333-21.333,21.333H309.333	c-5.896,0-10.667,4.771-10.667,10.667c0,5.896,4.771,10.667,10.667,10.667h160c11.76,0,21.333,9.573,21.333,21.333	C490.667,331.76,481.094,341.333,469.333,341.333z"
        fill="#fef3e9"
      />
      <path
        d="M384,448H106.667c-47.052,0-85.333-38.281-85.333-85.333V384	c0,47.052,38.281,85.333,85.333,85.333H384c11.76,0,21.333-9.573,21.333-21.333c0-3.969-1.384-7.48-3.28-10.667	C398.329,443.591,391.792,448,384,448z"
        opacity="0.1"
      />
      <circle cx="330.667" cy="53.333" r="32" fill="#303c42" />
      <circle cx="330.667" cy="53.333" r="10.667" fill="#fafafa" />
      <path
        d="M405.333,85.333c11.76,0,21.333-9.573,21.333-21.333s-9.573-21.333-21.333-21.333S384,52.24,384,64	S393.573,85.333,405.333,85.333z M416,64h-10.656c0,0-0.01-0.01-0.01-0.021L416,64z"
        fill="#303c42"
      />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="-44.861"
        y1="638.515"
        x2="-23.471"
        y2="628.54"
        gradientTransform="matrix(21.3333 0 0 -21.3333 996.333 13791.667)"
      >
        <stop offset="0" stopColor="#fff" stopOpacity="0.2" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
      <path
        d="M483.335,279.885c2.552-3.762,4.346-8.025,5.596-12.509C503.099,257.464,512,241.487,512,224	c0-25.76-18.365-47.313-42.677-52.26c0.01-0.365,0.01-0.719,0.01-1.073c0-21.844-16.5-39.906-37.688-42.375	c-7.479-13.188-21.531-21.625-36.979-21.625c-15.438,0-29.521,8.552-36.979,21.667c-3.781-0.427-7.469-0.479-11.354,0.031	c-7.448-13.135-21.531-21.698-37-21.698c-8.271,0-16.281,2.448-23.125,6.927c-5.521-4.417-12.365-6.927-19.542-6.927	c-17.646,0-32,14.354-32,32c0,13.917,8.938,25.792,21.375,30.188c-0.031,0.604-0.042,1.208-0.042,1.813c0,0.365,0,0.74,0.01,1.104	c-3.49-0.729-7.063-1.104-10.677-1.104c-25.754,0-47.298,18.353-52.254,42.667h-9.225c-5.375,0-8.135-3.542-9.073-5.063	c-0.948-1.521-2.875-5.573-0.469-10.375l34.25-68.5c3.125-6.24,4.771-13.229,4.771-20.208c0-24.917-20.271-45.188-45.188-45.188H160	c-2.958,0-5.781,1.229-7.802,3.385L37.292,190.5C13.25,216.271,0,249.875,0,285.115V384c0,58.813,47.854,106.667,106.667,106.667	H384c23.531,0,42.667-19.135,42.667-42.667c0-7.806-2.259-15.033-5.934-21.333H448c23.531,0,42.667-19.135,42.667-42.667	c0-8.845-2.707-17.066-7.332-23.885C499.969,354.288,512,338.602,512,320S499.969,285.712,483.335,279.885z M330.667,85.333	c17.646,0,32-14.354,32-32s-14.354-32-32-32c-17.646,0-32,14.354-32,32S313.021,85.333,330.667,85.333z M405.333,85.333	c11.76,0,21.333-9.573,21.333-21.333s-9.573-21.333-21.333-21.333S384,52.24,384,64S393.573,85.333,405.333,85.333z M416,64h-10.656	c0,0-0.01-0.01-0.01-0.021L416,64z"
        fill="url(#SVGID_1_)"
      />
    </svg>
  );
};

const USD = ({ width }) => {
  return (
    <svg
      width={"100%"}
      height={"100%"}
      stroke={"white"}
      fill={"white"}
      viewBox='0 0 511.99877 511'
      xmlns='http://www.w3.org/2000/svg'>
      <path d='m502.078125 139.734375c-3.167969 1.851563-6.640625 2.730469-10.0625 2.730469-6.878906 0-13.574219-3.550782-17.292969-9.917969-10.222656-17.511719-21.992187-33.722656-34.988281-48.1875-.085937-.097656-.171875-.195313-.257813-.296875-1.457031-1.683594-3.34375-3.75-3.953124-4.332031-.253907-.238281-.519532-.503907-.757813-.753907-.582031-.613281-2.648437-2.5-4.335937-3.957031-.097657-.082031-.199219-.171875-.292969-.257812-15.070313-13.539063-32.074219-25.59375-51.984375-36.847657-9.613282-5.4375-13.003906-17.640624-7.566406-27.253906 5.4375-9.617187 17.636718-13.003906 27.253906-7.566406 22.398437 12.664062 41.664062 26.332031 58.882812 41.78125 1.203125 1.042969 4.480469 3.917969 6.703125 6.195312 2.277344 2.222657 5.148438 5.496094 6.195313 6.703126 14.753906 16.441406 28.089844 34.8125 39.644531 54.605468 5.570313 9.539063 2.355469 21.785156-7.1875 27.355469zm-96.523437 160.28125c.46875 8.757813-4.820313 16.800781-13.050782 19.835937-1.121094.414063-112.386718 41.445313-127.195312 47.261719-7.15625 2.808594-15.289063 1.273438-20.921875-3.957031l-7-6.5c-.222657-.210938-.445313-.425781-.660157-.644531l-70.800781-72.113281c-3.84375 5.8125-8.132812 11.515624-12.855469 17.082031l-83.480468 98.402343c-.042969.054688-.085938.105469-.128906.152344-10.121094 11.691406-9.796876 29.03125.75 40.339844 11.304687 10.546875 28.644531 10.867188 40.335937.746094.050781-.042969.101563-.085938.152344-.128906l63.359375-53.75c8.425781-7.144532 21.046875-6.109376 28.191406 2.3125 7.144531 8.421874 6.109375 21.042968-2.3125 28.191406l-63.289062 53.683594c-13.222657 11.417968-29.554688 17.097656-45.855469 17.097656-10.582031 0-21.15625-2.402344-30.867188-7.171875l-25.785156 25.78125c-3.902344 3.90625-9.023437 5.859375-14.140625 5.859375s-10.238281-1.953125-14.140625-5.859375c-7.8125-7.808594-7.8125-20.472657 0-28.28125l25.03125-25.035157c-14.027344-25.203124-11.378906-57.125 8.257813-79.878906l83.417968-98.335937c8.726563-10.289063 15.453125-20.992188 19.988282-31.820313 6.90625-16.492187 47.300781-124.6875 47.707031-125.78125 3.058593-8.1875 11.074219-13.441406 19.808593-12.976562 3.023438.164062 74.675782 4.5625 131.5625 55.5625.941407.816406 2.871094 2.519531 4.34375 4.023437 1.503907 1.472657 3.207032 3.40625 4.023438 4.34375 50.996094 56.886719 55.394531 128.535157 55.554688 131.558594zm-41.886719-12.160156c-3.75-20.765625-14.378907-60.332031-43.558594-92.808594-.085937-.101563-.171875-.199219-.257813-.296875-.632812-.730469-1.515624-1.707031-1.847656-2.039062-.214844-.207032-.425781-.417969-.628906-.632813-.335938-.332031-1.3125-1.214844-2.042969-1.847656-.097656-.082031-.199219-.171875-.292969-.257813-32.753906-29.425781-72.179687-39.957031-92.859374-43.621094-9.308594 24.871094-27.878907 74.378907-37.601563 99.449219l78.082031 79.527344c24.5-9.203125 75.535156-28.066406 101.007813-37.472656zm44.359375-176.390625c-.898438-1.039063-3.3125-3.789063-5.285156-5.714844-1.921876-1.964844-4.667969-4.378906-5.710938-5.28125-9.871094-8.855469-20.632812-17.152344-31.976562-24.652344-9.214844-6.089844-21.621094-3.558594-27.714844 5.65625-6.089844 9.210938-3.558594 21.621094 5.65625 27.710938 9.761718 6.453125 18.996094 13.574218 27.449218 21.171875.097657.085937.195313.171875.292969.257812 1.285157 1.109375 2.890625 2.566407 3.347657 3.042969.246093.257812.480468.492188.742187.738281.488281.472657 1.945313 2.078125 3.054687 3.359375.085938.101563.171876.199219.261719.296875 9.726563 10.824219 18.628907 22.875 26.464844 35.808594 3.761719 6.210937 10.363281 9.640625 17.125 9.640625 3.53125 0 7.105469-.933594 10.34375-2.894531 9.449219-5.722657 12.46875-18.023438 6.746094-27.46875-9.097657-15.011719-19.457031-29.03125-30.796875-41.671875zm0 0'
      />
    </svg>
  )
}

export const Injection = ({ width }) => {
  return (
    <svg
      overflow="initial"
      viewBox="0 1 511 511.9995"
      width={`100%`}
      height={`100%`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m494.414062 102.046875-85.066406-85.066406c-3.808594-3.808594-3.808594-9.988281 0-13.800781l.324219-.320313c3.808594-3.8125 9.988281-3.8125 13.800781 0l85.0625 85.0625c3.8125 3.8125 3.8125 9.992187 0 13.800781l-.320312.324219c-3.8125 3.808594-9.992188 3.808594-13.800782 0zm0 0"
        fill="#737373"
      />
      <path
        d="m8.160156 512c-1.960937 0-3.921875-.75-5.417968-2.246094-2.992188-2.988281-2.992188-7.839844 0-10.832031l104.128906-104.128906c2.992187-2.992188 7.84375-2.992188 10.835937 0 2.988281 2.992187 2.988281 7.84375 0 10.832031l-104.128906 104.128906c-1.496094 1.496094-3.457031 2.246094-5.417969 2.246094zm0 0"
        fill="#737373"
      />
      <path
        d="m161.707031 384.714844-20.65625 20.65625c-6.285156 6.28125-16.46875 6.28125-22.75 0l-12.277343-12.28125c-6.28125-6.28125-6.28125-16.464844 0-22.746094l20.65625-20.65625"
        fill="#d7e4ef"
      />
      <path
        d="m252.632812 350.207031c-23.714843 23.714844-56.617187 35.867188-90.054687 33.257813-18.507813-1.441406-33.210937-16.144532-34.652344-34.652344-2.605469-33.433594 9.546875-66.335938 33.261719-90.050781l162.886719-162.886719 91.445312 91.441406zm0 0"
        fill="#d7e4ef"
      />
      <path
        d="m395.09375 166.890625-33.4375 33.4375-18.46875 18.464844-110.984375 110.984375c-23.714844 23.714844-56.617187 35.867187-90.050781 33.261718-4.042969-.316406-7.902344-1.261718-11.484375-2.742187 5.304687 12.8125 17.445312 22.042969 31.910156 23.167969 33.4375 2.609375 66.339844-9.546875 90.054687-33.257813l110.980469-110.984375 51.90625-51.90625zm0 0"
        fill="#c1ccd6"
      />
      <path
        d="m312.757812 290.082031s-28.542968 1.554688-48.460937-42.988281c-19.914063-44.539062-45.71875-45.71875-45.71875-45.71875l-57.390625 57.386719c-23.714844 23.714843-35.867188 56.617187-33.261719 90.054687 1.445313 18.507813 16.144531 33.210938 34.652344 34.652344 33.4375 2.605469 66.339844-9.546875 90.054687-33.261719zm0 0"
        fill="#5b9ed6"
      />
      <path
        d="m284.789062 277.195312-52.585937 52.582032c-23.714844 23.714844-56.617187 35.867187-90.050781 33.261718-4.042969-.316406-7.902344-1.261718-11.484375-2.742187 5.304687 12.8125 17.445312 22.042969 31.910156 23.167969 33.4375 2.609375 66.339844-9.546875 90.054687-33.257813l60.125-60.128906c0 .003906-13.234374.71875-27.96875-12.882813zm0 0"
        fill="#4f8aba"
      />
      <path
        d="m429.382812 201.183594-119.171874-119.175782c-4.691407-4.691406-4.691407-12.296874 0-16.984374l.394531-.394532c4.691406-4.691406 12.296875-4.691406 16.988281 0l119.171875 119.171875c4.691406 4.691407 4.691406 12.296875 0 16.984375l-.394531.398438c-4.691406 4.6875-12.296875 4.6875-16.988282 0zm0 0"
        fill="#b1bac4"
      />
      <path
        d="m434.152344 171.183594-17.382813 17.382812 12.417969 12.417969c4.800781 4.800781 12.582031 4.800781 17.382812 0 4.800782-4.800781 4.800782-12.582031 0-17.382813zm0 0"
        fill="#8f969e"
      />
      <path
        d="m354.828125 91.863281 64.699219-64.699219 64.699218 64.699219-64.699218 64.699219zm0 0"
        fill="#bdbdbd"
      />
      <path
        d="m419.53125 27.164062-10.980469 10.976563 33.964844 33.964844c7.042969 7.046875 7.042969 18.464843 0 25.507812l-40.964844 40.96875-46.71875-46.71875 64.699219 64.699219 64.699219-64.699219zm0 0"
        fill="#a1a1a1"
      />
      <g fill="#737373">
        <path d="m315.25 158.558594c-1.960938 0-3.917969-.75-5.414062-2.246094l-22.546876-22.546875c-2.992187-2.988281-2.992187-7.839844 0-10.832031 2.992188-2.992188 7.839844-2.992188 10.832032 0l22.546875 22.546875c2.992187 2.992187 2.992187 7.84375 0 10.832031-1.496094 1.496094-3.457031 2.246094-5.417969 2.246094zm0 0" />
        <path d="m288.324219 185.480469c-1.957031 0-3.917969-.746094-5.414063-2.242188l-22.546875-22.546875c-2.992187-2.992187-2.992187-7.84375 0-10.832031 2.992188-2.992187 7.84375-2.992187 10.832031 0l22.546876 22.546875c2.992187 2.992188 2.992187 7.839844 0 10.832031-1.496094 1.496094-3.453126 2.242188-5.417969 2.242188zm0 0" />
        <path d="m281.679688 232.683594c-1.957032 0-3.917969-.746094-5.414063-2.242188l-42.828125-42.824218c-2.988281-2.992188-2.988281-7.84375 0-10.835938 2.992188-2.988281 7.84375-2.988281 10.835938 0l42.824218 42.828125c2.992188 2.992187 2.992188 7.839844 0 10.832031-1.496094 1.496094-3.457031 2.242188-5.417968 2.242188zm0 0" />
        <path d="m234.476562 239.332031c-1.960937 0-3.921874-.75-5.417968-2.246093l-22.542969-22.542969c-2.992187-2.992188-2.992187-7.84375 0-10.835938 2.988281-2.992187 7.839844-2.992187 10.832031 0l22.546875 22.546875c2.988281 2.992188 2.988281 7.84375 0 10.832032-1.496093 1.496093-3.457031 2.246093-5.417969 2.246093zm0 0" />
        <path d="m207.554688 266.253906c-1.960938 0-3.921876-.746094-5.417969-2.242187l-22.546875-22.546875c-2.992188-2.992188-2.992188-7.84375 0-10.832032 2.992187-2.992187 7.84375-2.992187 10.832031 0l22.546875 22.546876c2.992188 2.988281 2.992188 7.839843 0 10.832031-1.496094 1.496093-3.457031 2.242187-5.414062 2.242187zm0 0" />
        <path d="m200.90625 313.460938c-1.960938 0-3.921875-.75-5.417969-2.246094l-42.824219-42.824219c-2.992187-2.992187-2.992187-7.84375 0-10.832031 2.992188-2.992188 7.84375-2.992188 10.835938 0l42.824219 42.824218c2.992187 2.992188 2.992187 7.84375 0 10.832032-1.496094 1.496094-3.457031 2.246094-5.417969 2.246094zm0 0" />
      </g>
    </svg>
  );
};

export const Relax = ({ width }) => {
  return (
    <svg
      overflow="initial"
      viewBox="0 1 511 511.9995"
      width={`100%`}
      height={`100%`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m63.902344 393.308594v110.886718c0 3.867188 3.132812 7 6.996094 7h14.582031c3.863281 0 6.996093-3.132812 6.996093-7v-110.886718zm0 0"
        fill="#aa493f"
      />
      <path
        d="m419.523438 393.308594v110.886718c0 3.867188 3.132812 7 6.996093 7h14.582031c3.863282 0 6.996094-3.132812 6.996094-7v-110.886718zm0 0"
        fill="#aa493f"
      />
      <path
        d="m83.285156 504.195312v-110.886718h-19.382812v110.886718c0 3.867188 3.132812 7 6.996094 7h14.582031c.84375 0 1.652343-.160156 2.402343-.433593-2.679687-.980469-4.597656-3.546875-4.597656-6.566407zm0 0"
        fill="#993b36"
      />
      <path
        d="m438.90625 504.195312v-110.886718h-19.382812v110.886718c0 3.867188 3.132812 7 6.996093 7h14.582031c.84375 0 1.652344-.160156 2.402344-.433593-2.679687-.980469-4.597656-3.546875-4.597656-6.566407zm0 0"
        fill="#993b36"
      />
      <path
        d="m503.007812 0h-75.9375c-2.972656 0-5.363281.824219-7.09375 3.296875l-34.652343 49.484375c-2.445313 3.496094-1.597657 8.316406 1.898437 10.761719 1.347656.945312 2.894532 1.398437 4.425782 1.398437 2.433593 0 4.832031-1.148437 6.335937-3.296875l32.34375-46.191406h72.679687c4.265626 0 7.726563-3.460937 7.726563-7.726563 0-4.269531-3.457031-7.726562-7.726563-7.726562zm0 0"
        fill="#dde4f7"
      />
      <g fill="#fec13b">
        <path d="m276.195312 45.722656c-5.566406 12.726563-2.089843 27.628906 9.089844 35.453125 11.179688 7.828125 26.371094 6 36.425782-3.582031zm0 0" />
        <path d="m335.296875 87.105469c-5.566406 12.726562-2.089844 27.628906 9.089844 35.457031 11.175781 7.824219 26.371093 5.996094 36.425781-3.585938zm0 0" />
        <path d="m394.398438 128.488281c-5.566407 12.726563-2.089844 27.628907 9.089843 35.457031 11.175781 7.824219 26.371094 5.996094 36.425781-3.585937zm0 0" />
      </g>
      <path
        d="m307.234375 81.175781c-7.320313-5.125-11.3125-13.285156-11.652344-21.878906l-19.386719-13.574219c-5.566406 12.726563-2.089843 27.628906 9.089844 35.453125 7.984375 5.589844 18.007813 6.230469 26.753906 2.664063-1.660156-.714844-3.273437-1.589844-4.804687-2.664063zm0 0"
        fill="#f9a332"
      />
      <path
        d="m366.335938 122.5625c-7.320313-5.125-11.3125-13.289062-11.652344-21.882812l-19.386719-13.574219c-5.566406 12.726562-2.089844 27.628906 9.089844 35.457031 7.984375 5.589844 18.007812 6.230469 26.753906 2.660156-1.660156-.714844-3.273437-1.589844-4.804687-2.660156zm0 0"
        fill="#f9a332"
      />
      <path
        d="m425.4375 163.945312c-7.320312-5.125-11.3125-13.289062-11.652344-21.882812l-19.386718-13.574219c-5.5625 12.726563-2.089844 27.628907 9.089843 35.457031 7.984375 5.589844 18.007813 6.230469 26.753907 2.660157-1.660157-.714844-3.273438-1.589844-4.804688-2.660157zm0 0"
        fill="#f9a332"
      />
      <path
        d="m497.90625 327.609375h-483.8125c-7.753906 0-14.09375 6.339844-14.09375 14.089844v14.09375c0 7.75 6.339844 14.09375 14.09375 14.09375h483.8125c7.75 0 14.09375-6.34375 14.09375-14.09375v-14.09375c0-7.75-6.339844-14.089844-14.09375-14.089844zm0 0"
        fill="#b9e1fb"
      />
      <path
        d="m36.058594 355.792969v-14.09375c0-7.75 6.339844-14.089844 14.09375-14.089844h-36.058594c-7.753906 0-14.09375 6.339844-14.09375 14.089844v14.09375c0 7.75 6.339844 14.09375 14.09375 14.09375h36.054688c-7.75 0-14.089844-6.34375-14.089844-14.09375zm0 0"
        fill="#9ad3f6"
      />
      <path
        d="m143.265625 313.519531v-14.09375c0-7.75-6.339844-14.089843-14.089844-14.089843h-115.082031c-7.753906 0-14.09375 6.339843-14.09375 14.089843v14.09375c0 7.75 6.339844 14.089844 14.09375 14.089844h115.082031c7.75 0 14.089844-6.339844 14.089844-14.089844zm0 0"
        fill="#9ad3f6"
      />
      <path
        d="m36.058594 313.519531v-14.09375c0-7.75 6.339844-14.089843 14.09375-14.089843h-36.058594c-7.753906 0-14.09375 6.339843-14.09375 14.089843v14.09375c0 7.75 6.339844 14.089844 14.09375 14.089844h36.054688c-7.75 0-14.089844-6.339844-14.089844-14.089844zm0 0"
        fill="#78cbf4"
      />
      <path
        d="m20.746094 369.886719v14.480469c0 7.75 6.339844 14.09375 14.09375 14.09375h442.320312c7.75 0 14.09375-6.34375 14.09375-14.09375v-14.480469zm0 0"
        fill="#b7594a"
      />
      <path
        d="m56.804688 384.367188v-14.480469h-36.058594v14.480469c0 7.75 6.339844 14.09375 14.09375 14.09375h36.058594c-7.753907 0-14.09375-6.34375-14.09375-14.09375zm0 0"
        fill="#aa493f"
      />
      <path
        d="m460.636719 131.785156c-.75-21.136718-10.363281-41.078125-27.996094-53.425781l-77.597656-54.332031c-17.636719-12.347656-39.660157-14.5625-59.777344-8.039063zm0 0"
        fill="#ccd7f2"
      />
      <path
        d="m338.367188 25.066406c-3.523438-2.464844-3.660157-6.976562-1.4375-9.835937-13.453126-4.070313-27.996094-3.675781-41.664063.757812l165.375 115.792969c-.308594-8.617188-2.113281-17.027344-5.308594-24.816406zm0 0"
        fill="#bccced"
      />
      <path
        d="m304.515625 179.503906c-3.496094-2.449218-4.347656-7.265625-1.898437-10.761718l16.4375-23.476563c2.449218-3.496094 7.265624-4.34375 10.761718-1.898437 3.496094 2.449218 4.34375 7.269531 1.894532 10.761718l-16.4375 23.476563c-2.445313 3.496093-7.261719 4.347656-10.757813 1.898437zm0 0"
        fill="#fcdfae"
      />
      <path
        d="m344.753906 197.878906c-4.1875-.832031-6.90625-4.898437-6.074218-9.085937l5.578124-28.109375c.832032-4.1875 4.894532-6.90625 9.082032-6.074219s6.90625 4.898437 6.074218 9.082031l-5.578124 28.109375c-.828126 4.183594-4.890626 6.90625-9.082032 6.078125zm0 0"
        fill="#fcdfae"
      />
      <path
        d="m273.488281 147.972656c-2.214843-3.648437-1.046875-8.398437 2.601563-10.613281l24.507812-14.855469c3.648438-2.210937 8.398438-1.046875 10.613282 2.605469 2.210937 3.648437 1.046874 8.398437-2.605469 10.613281l-24.503907 14.855469c-3.648437 2.207031-8.402343 1.046875-10.613281-2.605469zm0 0"
        fill="#fcdfae"
      />
      <path
        d="m205.386719 209.386719h-182.628907c-12.546874 0-22.757812-10.210938-22.757812-22.757813v-120.816406c0-12.550781 10.210938-22.757812 22.757812-22.757812h182.628907c12.550781 0 22.757812 10.207031 22.757812 22.757812v120.816406c0 12.546875-10.207031 22.757813-22.757812 22.757813zm0 0"
        fill="#dde4f7"
      />
      <path
        d="m36.058594 186.628906v-120.816406c0-12.550781 10.210937-22.757812 22.757812-22.757812h-36.058594c-12.546874-.003907-22.757812 10.207031-22.757812 22.757812v120.816406c0 12.546875 10.210938 22.757813 22.757812 22.757813h36.058594c-12.546875 0-22.757812-10.210938-22.757812-22.757813zm0 0"
        fill="#ccd7f2"
      />
      <path
        d="m197.070312 71.148438h-165.992187c-1.644531 0-2.980469 1.335937-2.980469 2.980468v104.179688c0 1.644531 1.335938 2.980468 2.980469 2.980468h165.992187c1.644532 0 2.980469-1.335937 2.980469-2.980468v-104.179688c0-1.644531-1.335937-2.980468-2.980469-2.980468zm0 0"
        fill="#63a1fc"
      />
      <path
        d="m64.15625 178.308594v-104.179688c0-1.644531 1.332031-2.980468 2.980469-2.980468h-36.058594c-1.644531 0-2.980469 1.335937-2.980469 2.980468v104.179688c0 1.644531 1.335938 2.980468 2.980469 2.980468h36.058594c-1.648438 0-2.980469-1.335937-2.980469-2.980468zm0 0"
        fill="#4188ff"
      />
      <path
        d="m84.828125 109.351562c-1.152344 1.296876-2.628906 1.101563-3.550781-.046874-6.96875-12.277344-25.832032-7.332032-25.832032 6.804687 0 19.242187 20.226563 30.679687 26.425782 33.726563.757812.375 1.644531.375 2.398437 0 6.203125-3.058594 26.433594-14.53125 26.433594-33.726563-.003906-14.074219-18.808594-19.144531-25.875-6.757813zm0 0"
        fill="#ff5155"
      />
      <path
        d="m83.90625 110.832031c0-.269531.019531-.527343.03125-.792969-.949219.453126-1.960938.132813-2.660156-.734374-6.96875-12.277344-25.832032-7.332032-25.832032 6.804687 0 19.242187 20.226563 30.679687 26.425782 33.726563.757812.375 1.644531.375 2.398437 0 3.203125-1.578126 10.132813-5.402344 16.097657-11.367188-7.746094-5.738281-16.460938-15.007812-16.460938-27.636719zm0 0"
        fill="#f24049"
      />
      <path
        d="m168.207031 106.738281h-30.53125c-4.269531 0-7.730469-3.457031-7.730469-7.726562s3.460938-7.726563 7.730469-7.726563h30.53125c4.265625 0 7.726563 3.457032 7.726563 7.726563s-3.460938 7.726562-7.726563 7.726562zm0 0"
        fill="#4188ff"
      />
      <path
        d="m168.207031 133.945312h-30.53125c-4.269531 0-7.730469-3.460937-7.730469-7.726562 0-4.269531 3.460938-7.726562 7.730469-7.726562h30.53125c4.265625 0 7.726563 3.457031 7.726563 7.726562 0 4.265625-3.460938 7.726562-7.726563 7.726562zm0 0"
        fill="#4188ff"
      />
      <path
        d="m168.207031 161.152344h-30.53125c-4.269531 0-7.730469-3.460938-7.730469-7.726563 0-4.269531 3.460938-7.726562 7.730469-7.726562h30.53125c4.265625 0 7.726563 3.457031 7.726563 7.726562 0 4.265625-3.460938 7.726563-7.726563 7.726563zm0 0"
        fill="#4188ff"
      />
      <path
        d="m465.492188 162.753906 6.152343-8.78125c4.445313-6.351562 2.886719-15.179687-3.460937-19.625l-177.210938-124.085937c-6.351562-4.445313-15.183594-2.890625-19.628906 3.460937l-6.148438 8.78125c-4.445312 6.347656-2.886718 15.179688 3.460938 19.625l177.210938 124.085938c6.351562 4.445312 15.183593 2.886718 19.625-3.460938zm0 0"
        fill="#dde4f7"
      />
      <path
        d="m303.644531 42.128906c-6.347656-4.445312-7.90625-13.277344-3.460937-19.625l2.722656-3.886718-11.933594-8.355469c-6.351562-4.445313-15.179687-2.890625-19.625 3.460937l-6.152344 8.78125c-4.441406 6.347656-2.886718 15.179688 3.460938 19.625l177.210938 124.085938c6.351562 4.445312 15.183593 2.886718 19.628906-3.460938l3.425781-4.894531zm0 0"
        fill="#ccd7f2"
      />
      <path
        d="m110.761719 243.519531c0 24.855469-20.152344 45.007813-45.007813 45.007813-24.855468 0-45.007812-20.152344-45.007812-45.007813 0-24.859375 20.152344-45.007812 45.007812-45.007812 24.855469 0 45.007813 20.148437 45.007813 45.007812zm0 0"
        fill="#ffcdbe"
      />
      <path
        d="m55.355469 243.519531c0-18.726562 11.4375-34.773437 27.703125-41.558593-5.328125-2.21875-11.171875-3.453126-17.304688-3.453126-24.855468 0-45.007812 20.152344-45.007812 45.007813 0 24.859375 20.152344 45.007813 45.007812 45.007813 6.132813 0 11.976563-1.230469 17.304688-3.453126-16.265625-6.777343-27.703125-22.828124-27.703125-41.550781zm0 0"
        fill="#f7c1b3"
      />
      <path
        d="m165.050781 281.640625c0-.3125.027344-.617187.054688-.917969l-30.582031-6.707031c-9.273438-2.257813-18.636719 3.425781-20.902344 12.707031-2.261719 9.277344 3.425781 18.636719 12.707031 20.898438l38.722656 8.691406c0-19.75 0-33.609375 0-34.671875zm0 0"
        fill="#ffcdbe"
      />
      <path
        d="m144.964844 290.484375c1.253906-5.140625 4.210937-9.421875 8.117187-12.398437l-18.558593-4.070313c-9.277344-2.257813-18.640626 3.425781-20.902344 12.707031-2.261719 9.277344 3.425781 18.636719 12.707031 20.898438l27.136719 6.09375c-7.054688-5.148438-10.695313-14.21875-8.5-23.230469zm0 0"
        fill="#f7c1b3"
      />
      <path
        d="m441.503906 293.015625h-54.28125v34.589844h54.28125c9.550782 0 17.296875-7.742188 17.296875-17.296875 0-9.550782-7.746093-17.292969-17.296875-17.292969zm0 0"
        fill="#ffcdbe"
      />
      <path
        d="m418.425781 293.015625h-31.203125v34.589844h31.203125c0-15.085938 0-27.324219 0-34.589844zm0 0"
        fill="#f7c1b3"
      />
      <path
        d="m380.328125 280.976562h-167.769531c-.796875 0-1.59375-.097656-2.367188-.285156l-35.882812-8.75c-6.285156-1.535156-12.347656 3.226563-12.347656 9.699219v187.695313c0 5.511718 4.46875 9.980468 9.984374 9.980468h208.382813c5.515625 0 9.984375-4.46875 9.984375-9.980468 0-2.085938 0-173.617188 0-178.375 0-5.515626-4.46875-9.984376-9.984375-9.984376zm0 0"
        fill="#63a1fc"
      />
      <path
        d="m198.152344 469.335938c0-3.058594 0-183.742188 0-187.695313 0-1.324219.265625-2.570313.722656-3.710937l-24.566406-5.988282c-6.285156-1.535156-12.347656 3.226563-12.347656 9.699219v187.695313c0 5.511718 4.46875 9.980468 9.984374 9.980468h36.195313c-5.515625 0-9.988281-4.46875-9.988281-9.980468zm0 0"
        fill="#4188ff"
      />
    </svg>
  );
};

export const Ultrasound = ({ width }) => {
  return (
    <svg
      overflow="initial"
      viewBox="0 0 512 512"
      width={`100%`}
      height={`100%`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m512 0v301l-30 30h-452l-30-30v-301zm0 0" fill="#596c76" />
      <path d="m512 0v301l-30 30h-226v-331zm0 0" fill="#465a61" />
      <path d="m181 362h150v120h-150zm0 0" fill="#bbdcff" />
      <path d="m256 362h75v120h-75zm0 0" fill="#9abadb" />
      <path d="m121 452h270v60h-270zm0 0" fill="#e0f4ff" />
      <path d="m256 452h135v60h-135zm0 0" fill="#bbdcff" />
      <path d="m512 301v91h-512v-91h241l15 15 15-15zm0 0" fill="#e0f4ff" />
      <path d="m512 301v91h-256v-76l15-15zm0 0" fill="#bbdcff" />
      <path
        d="m287.5 52.199219-12 12.300781c-5.101562 5.101562-12.300781 7.5-19.5 7.5s-14.398438-2.398438-19.5-7.5l-12-12.300781-109.199219 146.5 11.398438 9c1.5 1.199219 42.300781 33.300781 129.300781 33.300781s127.800781-32.101562 129.300781-33.300781l11.398438-9zm0 0"
        fill="#e0f4ff"
      />
      <g fill="#bbdcff">
        <path d="m361 60h91v30h-91zm0 0" />
        <path d="m385.300781 207.699219c-1.5 1.199219-42.300781 33.300781-129.300781 33.300781v-169c7.199219 0 14.398438-2.398438 19.5-7.5l12-12.300781 109.199219 146.5zm0 0" />
        <path d="m241 301h30v30h-30zm0 0" />
      </g>
      <path d="m256 301h15v30h-15zm0 0" fill="#9abadb" />
    </svg>
  );
};

export const Doctor = ({ width }) => {
  return (
    <svg
      overflow="initial"
      viewBox="0 0 450 450"
      width={`100%`}
      height={`100%`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M138.277,274.566c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 l-72.113,80.771L138.277,274.566z"
        fill="#ffd7a3"
      />
      <path
        d="M256.632,302.695l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H151.347 C159.845,254.744,216.054,296.663,256.632,302.695z"
        fill="#fdc88e"
      />
      <path
        d="M302.695,144.767c0,52.696-30.343,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 s41.246-72.384,92.124-72.384S302.695,92.071,302.695,144.767z"
        fill="#ffe1b2"
      />
      <path
        d="M121.521,156.283c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 C146.351,174.79,121.521,156.283,121.521,156.283z"
        fill="#ffe1b2"
      />
      <path
        d="M297.944,156.283c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S297.944,156.283,297.944,156.283z"
        fill="#ffe1b2"
      />
      <path
        d="M138.187,118.446c-2.742,7.887-6.58,52.643-6.58,52.643l-13.161-7.281l-3.701-48.234 L138.187,118.446z"
        fill="#7e5449"
      />
      <path
        d="M282.954,118.446c2.742,7.887,6.58,52.643,6.58,52.643l13.161-7.281l3.701-48.234L282.954,118.446z"
        fill="#7e5449"
      />
      <path
        d="M361.918,421.141c10.903,0,19.741-8.838,19.741-19.741v-50.303 c0-28.954-22.562-59.864-50.138-68.687l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039s-57.633-23.103-79.782-40.039 L89.62,282.41c-27.576,8.823-50.138,39.733-50.138,68.687V401.4c0,10.903,8.838,19.741,19.741,19.741H361.918z"
        fill="#527992"
      />
      <path
        d="M223.731,329.016c0,3.619-2.961,6.58-6.58,6.58H203.99c-3.619,0-6.58-2.961-6.58-6.58v-13.161 c0-3.619,2.961-6.58,6.58-6.58h13.161c3.619,0,6.58,2.961,6.58,6.58V329.016z"
        fill="#545465"
      />
      <circle cx="210.57" cy="368.498" r="6.58" fill="#d0d7dc" />
      <path
        d="M210.57,309.275l-27.456,27.456c-2.859,2.859-7.596,2.487-9.975-0.783l-48.113-66.156 l15.326-15.326c2.475-2.475,6.454-2.579,9.055-0.238L210.57,309.275z"
        fill="#475f7f"
      />
      <path
        d="M210.57,309.275l27.456,27.456c2.859,2.859,7.596,2.487,9.975-0.783l48.113-66.156l-15.326-15.326 c-2.475-2.475-6.454-2.579-9.055-0.238L210.57,309.275z"
        fill="#475f7f"
      />
      <polygon
        points="219.611,331.895 210.57,335.596 201.53,331.895 197.41,421.141 210.57,421.141 223.731,421.141"
        fill="#545465"
      />
      <path
        d="M364.235,420.907c9.797-1.16,17.423-9.399,17.423-19.507v-50.303 c0-28.954-22.562-59.864-50.138-68.687l-35.879-11.481h0l-52.169,149.978H364.235z"
        fill="#e4ebf0"
      />
      <path
        d="M125.499,270.929L125.499,270.929L89.62,282.41c-27.576,8.823-50.138,39.733-50.138,68.687V401.4 c0,10.109,7.627,18.347,17.423,19.507h120.764L125.499,270.929z"
        fill="#e4ebf0"
      />
      <path
        d="M125.026,269.793l-27.989,33.837c-2.605,2.993-1.988,7.594,1.314,9.795l13.515,9.01l-15.633,15.633 c-2.347,2.347-2.579,6.073-0.541,8.693l42.496,74.379l39.482-0.234L125.026,269.793z"
        fill="#d0d7dc"
      />
      <path
        d="M296.114,269.793l27.989,33.837c2.605,2.993,1.988,7.594-1.314,9.795l-13.515,9.01l15.633,15.633 c2.347,2.347,2.579,6.073,0.541,8.693l-42.496,74.379l-39.482-0.234L296.114,269.793z"
        fill="#d0d7dc"
      />
      <path
        d="M309.275,118.446c-65.803,0-131.606,0-197.41,0c0-35.095,0-59.654,0-94.749 c62.01-31.596,135.399-31.596,197.41,0C309.275,58.792,309.275,83.351,309.275,118.446z"
        fill="#e4ebf0"
      />
    </svg>
  );
};

export const Cardio = ({ width }) => {
  return (
    <svg
      overflow="initial"
      viewBox="0 0 450 450"
      width={`100%`}
      height={`100%`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_2_17_">
        <path
          d="M156.462,107.544c1.27-3.54,4.831-5.72,8.563-5.231c3.729,0.486,6.617,3.504,6.938,7.251 l12.784,149.365l23.939-86.291c0.979-3.527,4.212-5.953,7.886-5.859c3.659,0.081,6.797,2.634,7.619,6.201l13.331,57.833 l22.761-95.632c0.891-3.742,4.323-6.305,8.159-6.139c3.842,0.181,7.011,3.071,7.546,6.88l16.987,121.102l7.616-24.612 c1.037-3.35,4.136-5.635,7.643-5.635h85.587c12.562-18.914,21.501-37.745,24.475-55.858c6.528-40.089,0.16-73.151-18.97-98.252 c-19.317-25.34-48.66-39.798-89.789-44.203c-3.952-0.397-7.563-0.584-11.142-0.584c-29.108,0-58.456,10.825-81.01,29.135 c-22.522-18.31-51.896-29.135-80.948-29.135c-3.615,0-7.194,0.187-11.173,0.584C84.136,32.869,54.762,47.327,35.47,72.667 C16.345,97.769,9.971,130.83,16.501,170.919c3.021,18.399,12.189,37.533,25.055,56.739h71.809L156.462,107.544z"
          fill="#e74424"
        />
        <path
          d="M297.671,295.972c-1.108,3.58-4.561,5.914-8.285,5.609c-3.734-0.301-6.76-3.153-7.28-6.863 l-16.073-114.589l-20.852,87.612c-0.857,3.605-4.079,6.147-7.782,6.148c-0.01,0-0.019,0-0.028,0 c-3.716-0.013-6.933-2.583-7.768-6.203l-13.923-60.401l-27.402,98.771c-0.969,3.489-4.144,5.861-7.703,5.862 c-0.248,0-0.496-0.012-0.746-0.035c-3.855-0.358-6.9-3.426-7.23-7.284L159.147,147.44l-32.622,90.92 c-1.14,3.178-4.153,5.298-7.53,5.298H53.078c26.601,34.66,63.056,68.961,95.001,99.013c0,0,27.224,27.33,35.394,34.334 c6.166,5.28,19.484,15.892,33.94,15.892c14.435,0,27.784-10.612,33.913-15.892c8.171-7.005,35.394-34.334,35.394-34.334 c32.213-30.303,69.014-64.936,95.672-99.894h-68.258L297.671,295.972z"
          fill="#e74424"
        />
        <path
          d="M411.227,226.777h-17.405h-85.587c-3.507,0-6.605,2.285-7.643,5.635l-7.616,24.612 l-16.987-121.102c-0.535-3.809-3.704-6.699-7.546-6.88c-3.836-0.166-7.269,2.397-8.159,6.139l-22.761,95.632l-13.331-57.833 c-0.822-3.567-3.96-6.121-7.619-6.201c-3.674-0.094-6.907,2.332-7.886,5.859l-23.939,86.291l-12.784-149.365 c-0.32-3.747-3.208-6.765-6.938-7.251c-3.732-0.489-7.293,1.691-8.563,5.231l-43.097,120.114H41.557H8c-4.418,0-8,3.582-8,8 s3.582,8,8,8h45.078h65.917c3.376,0,6.39-2.12,7.53-5.298l32.622-90.92l13.452,157.159c0.33,3.858,3.375,6.925,7.23,7.284 c0.25,0.023,0.498,0.035,0.746,0.035c3.56,0,6.734-2.373,7.703-5.862l27.402-98.771l13.923,60.401 c0.835,3.621,4.052,6.19,7.768,6.203c0.01,0,0.019,0,0.028,0c3.703,0,6.925-2.543,7.782-6.148l20.852-87.612l16.073,114.589 c0.521,3.71,3.546,6.562,7.28,6.863c3.725,0.305,7.177-2.029,8.285-5.609l16.462-53.195h68.258h28.836c4.418,0,8-3.582,8-8 S415.645,226.777,411.227,226.777z"
          fill="#f7f1e6"
        />
      </g>
    </svg>
  );
};

const Container = styled.span`
  width: ${({width}) => width || '4'}rem;
  height: ${({height}) => height || '4'}rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SVGLoader = ({ name, width, height }, res) => {
  switch (name) {
    case 'usd':
      res = <USD width={width}/>;
      break;
    case 'hygiene':
      res = <Hygiene width={width} />;
      break;
    case 'ultrasound':
      res = <Ultrasound width={width} />;
      break;
    case 'injection':
      res = <Injection width={width} />;
      break;
    case 'relax':
      res = <Relax width={width} />;
      break;
    case 'doctor':
      res = <Doctor width={width} />;
      break;
    case 'cardio':
      res =  <Cardio width={width} />;
      break;
    default:
      return <div />;
  }
  return <Container width={width} height={height || width}>{res}</Container>
};
